import { apiClient } from "@/api/apiClient";

const RESOURCE = "communications/tickets";

export const fetchMessagesByTicketIdAsync = (
  ticketId: string,
  clientConfig = {},
) => {
  return apiClient(clientConfig).get(`${RESOURCE}/${ticketId}/messages`, {
    params: {
      sort: `["createdAt","ASC"]`,
    },
  });
};
